import { axiosInstance } from './index';

import BackendConstants from '../common/backendConstants';

export const loginService = (dataPayload) => {
  return axiosInstance.post(BackendConstants.login, dataPayload);
};
